import React from "react"
import "./TopPick.css"

const MiniSlots = props => (
  <div className="MiniSlot-Grid">
    {props.slot1}
    {props.slot2}
    {props.slot3}
    {props.slot4}
  </div>
)

export default MiniSlots